module.exports = __webpack_public_path__ + "img/07.fb55683d.jpg";